<template>
  <ContainerArea>
    <LayoutFill :no-gutters="true" :no-padding="true">
      <ResearchDirectionsBannerTop v-if="isResearchDirectionsItem" />
      <MainBanner
        :title="community.name"
        :description="community.description"
        :communities-header="true"
        :action="submitContent"
      />
    </LayoutFill>

    <LayoutGutters>
      <slot></slot>
      <ResearchDirectionsBannerBottom v-if="isResearchDirectionsItem" />
    </LayoutGutters>
  </ContainerArea>
</template>

<script>
import isUnauthorized from "~/plugins/utilities/isUnauthorized";

import ContainerArea from "~/components/layout/ContainerArea.vue";
import LayoutFill from "~/components/layout/LayoutFill.vue";
import LayoutGutters from "~/components/layout/LayoutGutters";
import MainBanner from "~/components/banner/MainBanner.vue";

import ResearchDirectionsBannerTop from "~/components/research-directions/ResearchDirectionsBannerTop.vue";
import ResearchDirectionsBannerBottom from "~/components/research-directions/ResearchDirectionsBannerBottom.vue";

export default {
  name: "CommunityDetailsContainer",
  components: {
    ContainerArea,
    LayoutFill,
    LayoutGutters,
    MainBanner,
    ResearchDirectionsBannerTop,
    ResearchDirectionsBannerBottom,
  },
  props: {
    community: { type: Object, required: true },
  },
  computed: {
    isResearchDirectionsItem() {
      return !!this.community.journalId;
    },
  },
  methods: {
    submitContent({ currentTarget }) {
      const redirectTo = `/engage/coe/submit-process/step-one?communityId=${this.community.id}`;

      if (isUnauthorized(this.$store.state.user, "USER")) {
        this.$root.$emit(
          "show-login-options-redirect",
          redirectTo,
          currentTarget
        );
      } else {
        this.$router.push({
          path: redirectTo,
        });
      }
    },
  },
};
</script>
